import { errors } from './errors';
import { filter } from './filter';
import { appTranslations } from './appTranslation';
import { localsPlacement } from './placement';

export const locals = {
  appTranslations,
  errors,
  filter,
  localsPlacement,
};
